export const roles = {
  SUPERADMIN: 'Superadmin',
  ADMIN: 'Administrator',
  REFERENT: 'Referent',
  CONTROLLER: 'Controller',
  SENDER: 'Sender',
  AUDITOR: 'Auditor',
  AUDITOR_VAT: 'AuditorVat',
  AUDITOR_RECEIVABLES: 'AuditorReceivables',
  COORDINATOR: 'Coordinator',
  VAT_DEDUCTION: 'VatDeduction',
  VAT_RECORDING: 'VatRecording',
  DESPATCH_ADVICES_SALES_OFFICER: 'SalesOfficer', // Outgoing Despatch / Incoming Receipt Advices
  DESPATCH_ADVICES_PROCUREMENT_OFFICER: 'ProcurementOfficer', // Incoming Despatch / Outgoing Receipt Advices
  CROSS_BORDER_TRANSACTIONS: 'CrossBorderTransactions',
}
